// API DOC = https://swiperjs.com/swiper-api
import Swiper from 'swiper/bundle';
import {findMany, on} from '../helpers';
import {slideOptions} from './slide';

// Find elements with the '[data-swipe-multiple]' attribute
const relatedElements = findMany('[data-swipe-related]');

// Define breakpoints for media queries in em
const breakpoints = [40, 48, 64];

// Function to check and update Swiper based on breakpoints and criteria
const slideCheck = () => {
    relatedElements.forEach(element => {
        const slides = findMany('.swiper-slide', element);

        if (slides.length > 1) {
            // Create a new Swiper instance for each element with custom configurations
            const swiper = new Swiper(element, {
                ...slideOptions,
                slidesPerView: 1,
                slidesPerGroup: 1,
                resistanceRatio: 0.5,
                spaceBetween: 12,
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        centeredSlides: false,
                        spaceBetween: 32,
                    },
                },
                navigation: {
                    nextEl: findMany('[data-swiper-next]', element),
                    prevEl: findMany('[data-swiper-prev]', element),
                    lockClass: 'opacity-0',
                    disabledClass: 'invisible',
                },
            });

            // Check if criteria (number of slides vs. slidesPerView) is met
            const criteria = swiper.slides.length < swiper.params.slidesPerView;

            // Check if any of the breakpoints match and criteria is met
            const matches = breakpoints.some(breakpoint =>
                window.matchMedia(`(min-width: ${breakpoint}em)`).matches,
            );

            // Disable or enable the Swiper based on conditions
            if (matches && criteria) {
                swiper.destroy();
            } else {
                swiper.enable();
            }
        }

        return null;
    });
};

// Attach event listeners for load and resize events
on('load', slideCheck, window);
on('resize', slideCheck, window);
